import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import {auth, database, db, API_URL} from './firebase'
import {getTrialTimeRemaining} from './core/utils/trial.utils'
import axios from 'axios'

Vue.use(Vuex)

const state = {
    // change ecommerce to kickstarter for crossprom.com
    platform: 'kickstarter',
    message: '',
    user: null,
    idToken: null,
    notifications: [],
    unreadMessages: false,
    data: {},
    searchResults: [],
    searchLoading: false,
    relatedCategory: '',
    serverTime: null,
    total: null,
    publishedCampaignIds: [],
    myShops: [],
    stripePublishableKey: null,
    stripePrices: null,
    openedDropdown: false,
    modals: {
        'cp-request': false,
        'login': false,
        'sign-up': false,
        'confirm-reg': false,
        'pass-change': false,
        'pass-pop': false,
        'forgot-pass': false,
        'camp-success': false,
        'sharable-content': false,
        'video-modal':false,
        'success-modal': false,
        'membership-modal': false,
        'pendings-modal':false,
        'send-message-modal': false,
        'processing-kickstarter-draft':false
    }
}

const mutations = {
    SET_USER: (state, user) => state.user = user,
    ID_TOKEN: (state, idToken) => state.idToken = idToken,
    SET: (state, [key, value]) => state[key] = value,
    ERR_MESSAGE: (state, message) => state.message = message,
    SET_SEARCH_RESULTS: (state, results) => state.searchResults = [...results],
    RESET_SEARCH_RESULTS: state => state.searchResults = [],
    SET_RELATED_CATEGORY: (state, category) => state.relatedCategory = category,
    TOGGLE_MODAL: (state, [key, value]) => state.modals[key] = value,
    CLOSE_MODALS: (state) => Object.keys(state.modals).forEach(
        (modal) => state.modals[modal] = false
    )
}

const actions = {
    handleErrors: ({commit}, e) => {
        console.log(e);

        if (e && e.message) {
            commit('ERR_MESSAGE', e.message)
        }
    },
    clearErrors: ({commit}) => {
        commit('ERR_MESSAGE','');
    },
    auth: ({ commit, state, dispatch, getters }) => {
        return new Promise((resolve, reject) => {
            auth.onAuthStateChanged(async user => {
                if (!user || (!user.emailVerified && user.providerData[0].providerId !== 'google.com')) {
                    resolve({authenticated: false})
                    return commit('SET_USER', false)
                }

                user
                    .getIdToken(true)
                    .then(
                        (idToken) => commit('ID_TOKEN', idToken)
                    )

                if(!getters.isEcommercePlatform) {
    
                    dispatch('getServerDate')
    
                    commit('SET', ['notifications', []])

                    const notifications = database
                        .ref(`notifications/${user.uid}`)
                        .orderByChild('date')
                    
                    const onNewNotification = (snapshot) => {
                        if(state.notifications.find(item => item.cprequestId && item.cprequestId === snapshot.val().cprequestId)){
                            return
                        }
                        commit('SET', [
                            'notifications',
                            [
                                {
                                    ...snapshot.val(),
                                    id: `notifications/${user.uid}/${snapshot.key}`
                                },
                                ...state.notifications
                            ]
                        ])
                    }

                    notifications.off('child_added')
                    notifications.on('child_added', onNewNotification)
                }
                
                commit('SET', ['unreadMessages', false])

                database
                    .ref(`unreadMessages/${user.uid}`)
                    .on(
                        'value',
                        (snapshot) => commit('SET', ['unreadMessages',snapshot.val()])
                    )

                const getPublishedCampaignIds = () => {
                    db.collection('campaigns')
                        .where('author_id', '==', user.uid)
                        .onSnapshot(
                            (querySnapshot) => {
                                state.publishedCampaignIds = querySnapshot.docs.map(
                                    camp => {
                                        return {
                                            id: camp.id,
                                            ...camp.data()
                                        }
                                    }
                                )
                            }
                        )
                }
                const getShops = () => {
                    db.collection('shops')
                        .where('owner_id', '==', user.uid)
                        .onSnapshot(
                            (querySnapshot) => {
                                state.myShops = querySnapshot.docs.map(
                                    shop => {
                                        return {
                                            id: shop.id,
                                            ...shop.data()
                                        }
                                    }
                                ).sort((a, b) => b.created_at.seconds - a.created_at.seconds)
                            }
                        )
                }
                getPublishedCampaignIds()    
                getShops()

                const userModel = db.collection(getters.usersCollection).doc(user.uid)

                if(getters.isEcommercePlatform) {
                    const result = await userModel.get()
                    if(!result.exists) {
                        const crosspromUser = await db.collection('Users').doc(user.uid).get()
                        if(crosspromUser.exists) {
                            const {email, name, userId, user_img, verified} = crosspromUser.data()
                            userModel.set({
                                email,
                                name,
                                userId,
                                user_img,
                                verified
                            })
                        }
                    }
                }

                userModel
                    .onSnapshot(doc => {
                        const userData = {...doc.data(), uid: doc.id}

                        if(userData.trial && state.user && !state.user.trial && !getters.isEcommercePlatform){
                            dispatch('getServerDate')
                        }

                        commit('SET', ['user', userData])

                        if(!localStorage.getItem('authenticated')){
                            localStorage.setItem('authenticated', true)
                        }

                        if(!userData.verified) {
                            userModel
                                .update({
                                    verified: true
                                })
                        }

                        if(!getters.isEcommercePlatform && userData.chosenPlanOnSignup && !userData.chosenPlanOnSignup.priceId && (!userData.modals || userData.modals && !userData.modals.outOfBetaShown)){
                            setTimeout(() => {
                                userModel.update({
                                    modals: {
                                        outOfBetaShown: true
                                    }
                                })
                                commit('TOGGLE_MODAL', ['out-of-beta', true])
                            }, 3000)
                        }
                        resolve({authenticated: true, user})
                    })
            })
        }) 
    },
    logout: ({ commit }) => {
        commit('SET_USER', false)
        commit('SET', ['publishedCampaignIds', []])
        auth.signOut().then(() => {
            localStorage.removeItem('authenticated')
        })
        router.push('/').catch(e => {})
    },

    getStripeKeys: async ({commit}) => {
        const resp = await axios(`${API_URL}/setup`)
        commit('SET', ['stripePublishableKey', resp.data.PUBLISHABLE_KEY])
        commit('SET', ['stripePrices', resp.data.PRICES])

        Vue.prototype.$stripe = Stripe(resp.data.PUBLISHABLE_KEY)
    },

    getServerDate: async ({commit}) => {
        const response = await axios(`${API_URL}/get-time`)
        commit('SET', ['serverTime', response.data])
    }
}

const getters = {
    inPremium: state => state.user && (state.user.premiumPlan && state.user.premiumPlan.status === 'active' || state.user.isAdmin),
    trialTimeRemaining: state => {
        if(state.user && state.user.trial && !state.user.subscription && state.serverTime) {
            return getTrialTimeRemaining(state.serverTime.currentDate, state.user.trial)
        }
        return null
    },
    // check if user is in trial now
    trialExpired: state => {
        return state.user && state.user.trial && (state.user.trial.endedEmailSent || state.serverTime && state.serverTime.dateSeconds - state.user.trial.endDate.seconds * 1000 > 0)
    },
    hasActionsLocked: (state, getters) => {
        return getters.hasTrial && getters.trialExpired && !getters.membershipStatus || getters.membershipStatus === 'canceled'
    },
    // check if user has trial activated
    hasTrial: state => {
        return state.user && state.user.trial
    },
    membershipStatus: state => {
        if(!state.user || !state.user.premiumPlan) return null
        return state.user.premiumPlan.status
    },
    lastAccecibleDate: state => {
        return state.user.subscription && state.user.subscription.endDate || 
            state.user.trial && state.user.trial.endDate
    },
    cancelAtPeriodEnd: state => {
        if(!state.user || !state.user.subscription) return null
        const {cancelAtPeriodEnd, status} = state.user.subscription
        return cancelAtPeriodEnd && status === 'active'
    },
    isEcommercePlatform: state => state.platform === 'ecommerce',
    usersCollection: state => state.platform === 'ecommerce' ? 'shopUsers' : 'Users'
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


